import React from "react";
import { noop } from "@common/helpers/function";
import { RuleStatus } from "@common/types/transactionRule";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps, defaultRuleStatuses } from "../../lib";

const ruleStatusDisplayLabels: Record<RuleStatus, string> = {
    [RuleStatus.ENABLED]: "Enabled",
    [RuleStatus.ARCHIVED]: "Archived",
};

const options: FilterMultiselectOption[] = Object.values(RuleStatus).map(
    (status) => ({
        value: status,
        label: ruleStatusDisplayLabels[status],
        searchableLabel: ruleStatusDisplayLabels[status],
    }),
);

export const RuleStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const statuses =
        filters.ruleStatuses && filters.ruleStatuses.length > 0
            ? filters.ruleStatuses
            : defaultRuleStatuses;

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={statuses}
            onChange={(val) => {
                onChange({ ruleStatuses: val as RuleStatus[] });
            }}
            name="ruleStatuses"
            onBlur={noop}
        />
    );
};
